<div class="sdp-section-container ">
	<mat-card class="sdp-administrative-card-container">
		<mat-card-content class="sdp-administrative-card-content">
			<div class="sdp-section-header-container">
				<sdp-icon [icon]="downloadIcon"></sdp-icon>
				{{ "download.title" | translate }}
			</div>
			<div class="sdp-download-description-container">{{ "download.description" | translate }}</div>
			<p *ngIf="autoRedirect">Redirecting to
				<a href="{{ downloadLink }}">download</a> in {{ redirectTime }}...
			</p>
			<p *ngIf="!autoRedirect">
				<a href="{{ downloadLink }}">Click here</a>
			</p>
		</mat-card-content>
	</mat-card>
</div>